import React, { useState, useEffect } from "react";
import "../../../style/google_forms.css";
import { useFormSubmission } from "../../pages/payment/customPayment";
import { EmailInput, RadioButtonInput, PhoneNumberInput } from "../../components/FormInitiators";
import { Loader } from "lucide-react";
import LoadingPage from "../../Loader";

function SrPlacementForm() {

  const initialFormState = {
    uniqueFormId: "",
    officeName: "",
    employeeName: "",
    email: "",
    phoneNumber: "",
    gender: "",

    existingDesignation: '',
    existingPayLevel: '',
    existingPayInLevel: '',
    
    placementDate: '',
    
    revisedDesignation: '',
    revisedPayLevel: '',
    fixation_till_month: '',
    fixation_till_year: '',
    remark: '',
  };
  const dummyFormData = {
  employeeName: "Senior Placement",
    officeName: "LBS COLLEGE SATARA",
    email: "survechinmay6@gmail.com",
    gender: "Male",
    handicapped: "No",
    phoneNumber: "9406546508",

  existingDesignation: 'Assistant Professor',
  existingPayLevel: 'AL-11 : 68900--205500',
  existingPayInLevel: '95300',
  placementDate: '2021-05-15',
  revisedDesignation: 'Associate Professor',
  revisedPayLevel: 'AL-11 : 68900--205500',
  fixation_till_month: '1',
  fixation_till_year: '2024',
  remark: 'No remarks',

  }
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("SalaryDetails")) || [];
    setFormData((prev) => ({ ...prev, salaryDetails: storedData }));
  }, []);

  const [formData, setFormData] = useState(initialFormState);
  const { handleFormSubmission, isSubmitting, PaymentWindowComponent } = useFormSubmission();


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const formConfig = {
    apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/srPlacementForm/submit-srPlacement`,
    successRoute: "/srPlacementForm/srPlacement-result",
    formType: "Sr_Placement",
      name: formData.employeeName,
      email: formData.email,
      contact: formData.phoneNumber,
    onSuccessCallback: () => localStorage.clear(),
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleFormSubmission(formData, formConfig);
  };


  return (
    <div>
    <div className="google_forms">
 
      <form className="forms" onSubmit={handleSubmit}>
        <h2>Senior Placement Information</h2>

        <div>
          <label>Name of the Office</label>
          <input type="text" name="officeName" value={formData.officeName} onChange={handleInputChange} />
        </div>

        <div>
          <label>Name of Employee</label>
          <input type="text" name="employeeName" value={formData.employeeName} onChange={handleInputChange} />
        </div>

        <div>
          <EmailInput name="email" value={formData.email} onChange={handleInputChange} />
        </div>

        <div>
          <PhoneNumberInput name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} />
        </div>

        <div>
          <label>Gender:</label>
          <RadioButtonInput
            value={formData.gender}
            name="gender"
            orientation="horizontal"
            options={[
              { value: "Male", label: "Male" },
              { value: "Female", label: "Female" },
            ]}
            onChange={handleInputChange}
          />
        </div>
    
        <div>
          <label>Existing Designation:</label>
          <select name="existingDesignation" value={formData.existingDesignation || ""} onChange={handleInputChange}>
            <option value="" disabled>
              Select Designation
            </option>
            <option value="Assistant Professor">Assistant Professor</option>
            <option value="Associate Professor">Associate Professor</option>
            <option value="Professor">Professor</option>
          </select>
        </div>

        <div>
        <label>Existing Pay Level</label>
          <select name="existingPayLevel" value={formData.existingPayLevel || ""} onChange={handleInputChange}>
            <option value="" disabled>
              Select Pay Level
            </option>
            <option value="AL-10 : 57700--182400">AL-10 : 57700--182400</option>
            <option value="AL-11 : 68900--205500">AL-11 : 68900--205500</option>
            <option value="AL-12 : 79800--211500">AL-12 : 79800--211500</option>
            <option value="AL-13A : 131400--217100">AL-13A : 131400--217100</option>
            <option value="AL-14 : 144200--218200">AL-14 : 144200--218200</option>
            <option value="AL-15 : 182200--224100">AL-15 : 182200--224100</option>
          </select>
        </div>

        <div>
            <label>Existing Pay In Pay Level</label>
            <input type="number" name="existingPayInLevel" value={formData.existingPayInLevel} onChange={handleInputChange} />
        </div>

        <div>
          <label>Date of Placement</label>
          <input type="date" name="placementDate" value={formData.placementDate} onChange={handleInputChange} />
        </div>

        <div>
          <label>Revised Designation:</label>
          <select name="revisedDesignation" value={formData.revisedDesignation || ""} onChange={handleInputChange}>
            <option value="" disabled>
              Select Designation
            </option>
            <option value="Assistant Professor">Assistant Professor</option>
            <option value="Associate Professor">Associate Professor</option>
            <option value="Professor">Professor</option>
          </select>
        </div>

        <div>
        <label>Revised Pay Level</label>
          <select name="revisedPayLevel" value={formData.revisedPayLevel || ""} onChange={handleInputChange}>
            <option value="" disabled>
              Select Pay Level
            </option>
            <option value="AL-11 : 68900--205500">AL-11 : 68900--205500</option>
            <option value="AL-12 : 79800--211500">AL-12 : 79800--211500</option>
            <option value="AL-13A : 131400--217100">AL-13A : 131400--217100</option>
            <option value="AL-14 : 144200--218200">AL-14 : 144200--218200</option>
            <option value="AL-15 : 182200--224100">AL-15 : 182200--224100</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            {/* Month Selection */}
            <div>
            <label>Fixation Till Month</label>
            <select 
              name="fixation_till_month" 
              value={formData.fixation_till_month} 
              onChange={handleInputChange}
            >
          <option value="" disabled>Select Month</option>  {/* Disabled default option */}
          <option value="1">January</option>
          <option value="7">July</option>
          </select>
        </div>


            {/* Year Selection */}
            <div>
              <label>Fixation Till Year</label>
              <select name="fixation_till_year" value={formData.fixation_till_year} onChange={handleInputChange}>
                <option value="" disabled>Select Year</option> 
                {Array.from({ length: 14 }, (_, i) => {
                  const year = 2016 + i;
                  return <option key={year} value={year}>{year}</option>;
                })}
              </select>
            </div>
          </div>

          <div>
          <label>Remark: (optional)</label>
          <input type="text" name="remark" value={formData.remark} onChange={handleInputChange} />
        </div>


        <button
               className="single-button submit-button gap-2 px-4 py-2 text-white rounded-lg flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed relative"
               type="submit"
               disabled={isSubmitting}
             >
               {isSubmitting && <Loader className="animate-spin mr-2" />}
               {isSubmitting ? "Submitting..." : "Submit"}
             </button>
       
      </form>
  

    </div>
    {isSubmitting}
    {PaymentWindowComponent}
    </div>
  );
}

export default SrPlacementForm;
